import React from 'react';
import propTypes from 'prop-types';
import './index.css';
import PoiAction from './PoiAction';
import MainInfo from './MainInfo';
import {Text, PhoneNumber, Link} from './InfoItem';
import {LineDesc} from '../Desc';
import Address from './Address';
import LittleAskCard from '../../LittleAskCard';
import Comment from '../Comment';
import Station from './Station';
import ReserveList from './ReserveList';
import Videos from './Videos';
import Tags from './Tags';
import { getStayTime } from '../../../helpers/poi';
import Detector from '../../../utils/detector';

export default class Introduction extends React.Component {
  static propTypes = {
    poi: propTypes.object.isRequired,
    city: propTypes.object.isRequired,
    // onAdd与onRemove均可选，但最多只能传递一个
    onAdd: propTypes.func,
    onRemove: propTypes.func
  };

  render() {
    let { poiType, poi, city, videos, onAdd, addActionBtnText, onRemove,
      nextAttraction, needShowMoreAttraction, needShowMoreFood, nextFood,
      showComment, comments, commentType, handleClickAddress,handleClickAskCard } = this.props;
    let { showMore, handleClickNextStation, tabType} = this.props;
    let { desc, open_time, average_prices, park_info, stay_agv, tel, tips, arrival, website, wiki_url, ticket } = poi.info;
    let browserName = Detector.browser.name;
    return (
      <div className="introduction" id={browserName}>
        <PoiAction poi={poi} city={city} addActionBtnText={addActionBtnText} onAdd={onAdd} onRemove={onRemove} />
        <MainInfo poi={poi} tabType={tabType} poiType={poiType} bannerVideo={videos.bannerVideo}/>
        <Tags
          tagList={poi.attach_info.recommended_list}
          poiType={poiType}
        />
        <ReserveList reserveInfo={poi.reserve_info} />
        <Videos videos={videos.videoList} poi_uid={poi.poi_uid}/>
        <section className="basic-info">
          <LineDesc text="简介" desc={desc} wikiUrl={wiki_url} line="3" tjKey="poi_moreIntroduction_click"/>
          <LineDesc text="贴士" desc={tips} tjKey="poi_moretips_click"/>
          <Address poi={poi} handleClickAddress={handleClickAddress}/>
          <LittleAskCard poi={poi} handleClickAskCard={handleClickAskCard}/>
          <Text text="营业" data={open_time} />
          { (poiType ==='food' || poiType=== 'entertainment')
            && average_prices && average_prices.length > 0 ?
            <Text text="消费" data={`${average_prices[average_prices.length-1]}`}/>
            : null
          }
          { (poiType ==='attraction' || poiType === 'entertainment' || poiType === 'user_travel')
            && stay_agv ?
            <Text text="时长" data={`建议游玩${getStayTime(poi)}小时`}/> : null}
          <LineDesc text="交通" desc={arrival} tjKey="poi_moretraffic_click"/>
          <LineDesc text="停车" desc={park_info} />
          <LineDesc text="门票" desc={ticket} />
          <PhoneNumber text="电话" data={tel} />
          <Link text="网址" data={website} />
        </section>
        {
          poiType ==='hotel' && poi.info.facility ?
            <Tags
              className='facility'
              title="酒店设施"
              tagList={poi.info.facility}
              poiType={poiType}
            /> : null
        }
        {
          showComment ?
            <Comment
              commentType={commentType}
              showCountTitle={true}
              comments={comments}
              showMore={showMore}
              handleChangeCommentType={this.props.handleChangeCommentType}/>
            : null
        }

        <Station
          type="attraction"
          title="景点"
          className={!nextAttraction.length || !nextFood.length ? 'last': ''}
          stationList={nextAttraction}
          needShowMore={needShowMoreAttraction}
          showMore={showMore}
          handleClickNextStation={handleClickNextStation}/>
        <Station
          type="food"
          title="美食"
          className="last"
          stationList={nextFood}
          needShowMore={needShowMoreFood}
          showMore={showMore}
          handleClickNextStation={handleClickNextStation}/>
      </div>
    );
  }
}








// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/index.js